import './App.scss';
import Header from './components/Header';
import Footer from './components/Footer';
import Cards from './components/Cards';
import { schools } from './schools';
import { useState } from 'react';

function App() {
  const [schoolsList, setSchoolsList] = useState(schools)

  const list = Object.keys(schoolsList).map(iteration => {
    return (
      <Cards
        key={iteration} 
        mykey={iteration}
        nom={schoolsList[iteration].title}
        logo={schoolsList[iteration].logo}
        tel={schoolsList[iteration].tel}
        adresse={schoolsList[iteration].adresse}
        cp={schoolsList[iteration].cp}
        mail={schoolsList[iteration].email}
        ville={schoolsList[iteration].ville}
        url={schoolsList[iteration].url}
      />
    )
  })

  return (
   <>
    <div className="slide" id="home">
      <Header />
      <div className="container">
            <div className="wrapper">
              <div className="container-logo">
                  <img src="/images/LogoCSRWaPi2024.svg" alt="Logo CSR WaPi"/>
              </div>
                <div id="jumbotron">
                  <div className="contain">
                    <h1 className="title">ENSEIGNEMENT POUR ADULTES</h1>
                    <h2>Anciennement Enseignement de Promotion Sociale</h2>
                    <div className="texte">
                      <p>C.S.R - WAPI - Enseignement pour Adultes de Wallonie Picarde.</p>
                      <p>Un enseignement pour Adultes tout au long de la vie & Formations Continuées</p>
                    </div>
                    <div className="buttons">
                      <a className="btn dark" href="#schools">Voir les établissements</a>
                      <a className="btn blue" href="EA-WAPI-Cadastre_des_formations2026-2027.pdf" target='_blank'>Cadastre des formations EA</a>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
    <div className="slide" id="schools">
      <div className="wrapper">
            <h2>NOS ECOLES D'ENSEIGNEMENT POUR ADULTES EN WALLONIE PICARDE</h2>
            <div id="myschools">
              {list}
            </div>
      </div>
    </div>
    <Footer />
   </>
  );
}

export default App;
